import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { Alert } from "@mui/material";
import { useState } from "react";
import { vendorInvoiceStyles } from "../style";

const InvoiceErrors = ({ invoice }) => {
    const classes = vendorInvoiceStyles();
    const [open, setOpen] = useState(false);
    const text = <>{invoice?.errorList?.length} {invoice?.errorList?.length > 1 ? 'Errors' : 'Error'}</>;
    return (
        <>
            {/* {!!invoice?.errorList?.length && <Button variant="outlined" color="primary" size="small" onClick={() => setOpen(true)}>
                {text}
            </Button>} */}
            {!!invoice?.errorList?.length && <Chip className={classes.warningChip} label={text} size='small' variant="outlined" onClick={() => setOpen(true)} >{text}</Chip>}
            <Dialog open={open} maxWidth="xs" fullWidth onClose={() => setOpen(false)}>
                <DialogTitle>Invoice Errors</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} direction="column">
                        {invoice?.errorList?.map((error, index) => (
                            <Grid item key={index}>
                                <Alert key={index} severity="warning">{error?.description}</Alert>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default InvoiceErrors;
